// @flow
import React from "react";
import { ThemeProvider } from "styled-components";

import GlobalStyles from "../../styles/globalStyles";
import Routes from "../../routes";
import ThemeContext from "../../context/theme";

const App = () => {
  const { isDark, fontSize } = React.useContext(ThemeContext);

  React.useEffect(() => {
    const elem = document.getElementById("initLoader");
    window.onload = () => {
      if (elem) {
        elem.remove();
      }
    };
  }, []);

  return (
    <ThemeProvider theme={{ mode: isDark ? "dark" : "light", text: fontSize }}>
      <GlobalStyles />
      <Routes />
    </ThemeProvider>
  );
};

export default App;
